import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Switch } from "../ui/switch";
import { Badge } from "../ui/badge";
import { GoogleAddressInput } from "../GoogleAddressInput";
import { formatDateTime } from "../../lib/format";

export const MOBILIZZAZIONI = ["Autonomo", "Carrozzina", "Barella"];
export const EMPTY_SR = {
  paziente_nominativo: "", reparto_partenza: "", destinazione_nome: "", destinazione_indirizzo: "",
  data_ora_carico: "", orario_visita: "", motivo: "", mobilizzazione: "", andata_ritorno: false, note: "",
};
export const pickSR = (d) => Object.fromEntries(Object.keys(EMPTY_SR).map((k) => [k, d?.[k] ?? EMPTY_SR[k]]));

const STATO_CLS = {
  ricevuta: "bg-amber-100 text-amber-800 border-amber-200",
  presa_in_carico: "bg-sky-100 text-sky-800 border-sky-200",
  assegnata: "bg-emerald-100 text-emerald-800 border-emerald-200",
};
const STATO_LABEL = { ricevuta: "Ricevuta", presa_in_carico: "Presa in carico", assegnata: "Assegnata" };
export const SRStatoBadge = ({ stato, testid }) => (
  <Badge data-testid={testid} variant="outline" className={`font-semibold ${STATO_CLS[stato] || ""}`}>{STATO_LABEL[stato] || stato}</Badge>
);

const F = ({ label, full, children }) => (
  <div className={full ? "md:col-span-2" : ""}><Label className="nx-label">{label}</Label>{children}</div>
);

const MobPicker = ({ value, onChange }) => (
  <div className="mt-1.5 grid grid-cols-3 gap-2">
    {MOBILIZZAZIONI.map((m) => (
      <button key={m} type="button" data-testid={`sr-mob-${m.toLowerCase()}`} onClick={() => onChange(m)}
        className={`rounded-md border px-3 py-2 text-sm font-medium transition-colors ${value === m ? "border-primary bg-primary text-white" : "border-slate-200 bg-white text-slate-700 hover:border-primary/50"}`}>
        {m}
      </button>
    ))}
  </div>
);

export const SRForm = ({ value, onChange }) => {
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  const inp = (k, props = {}) => <Input data-testid={`sr-${k}`} value={value[k]} onChange={(e) => set(k)(e.target.value)} className="mt-1.5" {...props} />;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <F label="Nominativo paziente *" full>{inp("paziente_nominativo")}</F>
      <F label="Reparto di partenza">{inp("reparto_partenza", { placeholder: "Es. Cardiologia, 3° piano" })}</F>
      <F label="Struttura di destinazione *">{inp("destinazione_nome", { placeholder: "Es. Ospedale San Raffaele" })}</F>
      <F label="Indirizzo destinazione" full>
        <GoogleAddressInput testid="sr-destinazione_indirizzo" value={value.destinazione_indirizzo} onChange={set("destinazione_indirizzo")}
          onPick={(p) => onChange({ ...value, destinazione_indirizzo: p.indirizzo })} placeholder="Cerca l'indirizzo della destinazione..." />
      </F>
      <F label="Data e ora di carico *">{inp("data_ora_carico", { type: "datetime-local" })}</F>
      <F label="Orario della visita">{inp("orario_visita", { type: "time" })}</F>
      <F label="Motivo del trasporto" full>{inp("motivo", { placeholder: "Es. visita specialistica, dimissione, dialisi" })}</F>
      <F label="Mobilizzazione *"><MobPicker value={value.mobilizzazione} onChange={set("mobilizzazione")} /></F>
      <F label="Tratta">
        <label className="mt-1.5 flex items-center gap-3 rounded-md border border-slate-200 bg-white px-3 py-2 cursor-pointer">
          <Switch data-testid="sr-andata_ritorno" checked={!!value.andata_ritorno} onCheckedChange={set("andata_ritorno")} />
          <span className="text-sm text-slate-700">{value.andata_ritorno ? "Andata e Ritorno" : "Solo andata"}</span>
        </label>
      </F>
      <F label="Note" full>
        <Textarea data-testid="sr-note" rows={3} value={value.note} onChange={(e) => set("note")(e.target.value)} className="mt-1.5" />
      </F>
    </div>
  );
};

const ROWS = [
  ["Nominativo paziente", (d) => d.paziente_nominativo], ["Reparto di partenza", (d) => d.reparto_partenza],
  ["Struttura di destinazione", (d) => d.destinazione_nome], ["Indirizzo destinazione", (d) => d.destinazione_indirizzo],
  ["Data e ora di carico", (d) => formatDateTime(d.data_ora_carico)], ["Orario della visita", (d) => d.orario_visita],
  ["Motivo del trasporto", (d) => d.motivo], ["Mobilizzazione", (d) => d.mobilizzazione],
  ["Tratta", (d) => (d.andata_ritorno ? "Andata e Ritorno" : "Solo andata")], ["Note", (d) => d.note],
];

export const SRReadOnly = ({ data }) => (
  <dl data-testid="sr-readonly" className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
    {ROWS.map(([label, get]) => (
      <div key={label} className={label === "Note" || label === "Indirizzo destinazione" ? "md:col-span-2" : ""}>
        <dt className="nx-label">{label}</dt>
        <dd className="text-sm text-slate-800 mt-1 whitespace-pre-wrap">{get(data) || "—"}</dd>
      </div>
    ))}
  </dl>
);
